export interface HeaderActionsFitInput {
  availableWidth: number;
  titleWidth: number;
  actionsWidth: number;
  chromeWidth: number;
  rowGap: number;
  chromeGap: number;
}

export function headerActionsFitInTitleRow({
  availableWidth,
  titleWidth,
  actionsWidth,
  chromeWidth,
  rowGap,
  chromeGap,
}: HeaderActionsFitInput): boolean {
  if (availableWidth <= 0) {
    return false;
  }
  if (actionsWidth <= 0) {
    return true;
  }
  const rightWidth = chromeWidth > 0 ? actionsWidth + chromeGap + chromeWidth : actionsWidth;
  return titleWidth + rowGap + rightWidth <= availableWidth;
}

export function intrinsicFlexContentWidth(element: HTMLElement): number {
  const children = Array.from(element.children) as HTMLElement[];
  if (children.length === 0) {
    return 0;
  }
  const styles = getComputedStyle(element);
  const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
  return children.reduce((width, child, index) => {
    return width + child.getBoundingClientRect().width + (index > 0 ? gap : 0);
  }, 0);
}
